import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { SetorStorage } from '../../../entidade/almoxarifado/setor-storage.model';
import { BaseResourceService } from '../../../models/services/base-resource.service';

@Injectable({
  providedIn: 'root'
})
export class SetorStorageService extends BaseResourceService<SetorStorage> {

  constructor(
    protected injector: Injector
  ) {
    super(`setor-storages`, injector);
  }

  public upload(arquivos: any[], orgao: number, Setor: number, descricao?: string): Observable<SetorStorage[]> {
    const formData = new FormData();
    for (let arquivo of arquivos) {
      formData.append('files', arquivo);
    }
    if (descricao) {
      formData.append('descricao', descricao);
    }

    const headers = this.httpOptions();
    headers.headers = headers.headers.delete('Content-Type');

    return this.http.post<SetorStorage[]>(`${this.login.cidade.id}/${this.api}/upload/${orgao}/${Setor}`,
      formData, headers)
      .pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }
}
